import {
  MuiEvent,
  GridRowId,
  GridEventListener,
  GridRowModesModel,
  GridRowModes,
  GridRowModel,
  GridRowParams,
} from "@mui/x-data-grid-pro"
import { useTableContext } from "../provider"

export const useEditorRow = () => {

  const ctx = useTableContext()

  const onRowEditStart: GridEventListener<"rowEditStart"> = (params, event) => {
    event.defaultMuiPrevented = true
  }

  const onRowEditStop: GridEventListener<"rowEditStop"> = (params, event) => {
    event.defaultMuiPrevented = true
  }
  const onCellKeyDown: GridEventListener<"cellKeyDown"> = (params, event, details) => {
    const { api } = details
    const rowMode = api.getRowMode(params.id)

    if (rowMode === "edit") {
      event.defaultMuiPrevented = true
      if (event.key === "Enter") {
        ctx.editor.api.save(params.row.id)
      }
      if (event.key === "Escape") {
        ctx.editor.api.cancel(params.row.id)
      }
    }
  }

  const tableProps = {
    experimentalFeatures: { newEditingApi: true },
    rowModesModel: ctx.editor.state.rowModes,
    onRowModesModelChange: ctx.editor.api.setRowModesModel,
    processRowUpdate: ctx.props.processRowUpdate,
    onProcessRowUpdateError: ctx.props.onProcessRowUpdateError,
    onRowEditStart,
    onRowEditStop,
    onCellKeyDown,
  }

  return {
    tableProps,
  }
}
